// Legacy tabs may still have the string 'null' from an older stop-impersonation path.
export const getImpersonatedAuthId = (): string | null => {
  const impersonatedAuthId = sessionStorage.getItem('impersonatedAuthId');
  return impersonatedAuthId && impersonatedAuthId !== 'null' ? impersonatedAuthId : null;
};

// Used by the axios request interceptor; kept here so the header rule is testable without booting MSAL.
export const applyImpersonationHeader = (headers: Record<string, unknown>): void => {
  const impersonatedAuthId = getImpersonatedAuthId();
  if (impersonatedAuthId) {
    headers['X-Impersonate-Id'] = impersonatedAuthId;
  }
};
